import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EditorWysiwyg = ({ height = 97, width = 174, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 174 97" {...props}>
    <path
      fill="#FFFFFF"
      d="M9,1h156c4.4,0,8,3.6,8,8v79c0,4.4-3.6,8-8,8H9c-4.4,0-8-3.6-8-8V9C1,4.6,4.6,1,9,1z"
    />
    <path
      fill="none"
      stroke="#F5F4F4"
      d="M9,0.5h156c4.7,0,8.5,3.8,8.5,8.5v79c0,4.7-3.8,8.5-8.5,8.5H9c-4.7,0-8.5-3.8-8.5-8.5V9
      C0.5,4.3,4.3,0.5,9,0.5z"
    />
    <path fill="#F5F4F4" d="M1,12v76c0,4.4,3.6,8,8,8h156c4.4,0,8-3.6,8-8V12H1z" />
    <path
      fill="#FFFFFF"
      d="M64,19h46c2.2,0,4,1.8,4,4v62c0,2.2-1.8,4-4,4H64c-2.2,0-4-1.8-4-4V23C60,20.8,61.8,19,64,19z"
    />
    <path
      fill="#FFFFFF"
      stroke="#F5F4F4"
      d="M72,47.5h30c1.9,0,3.5,1.6,3.5,3.5v26c0,1.9-1.6,3.5-3.5,3.5H72c-1.9,0-3.5-1.6-3.5-3.5V51
      C68.5,49.1,70.1,47.5,72,47.5z"
    />
    <path fill="#E6FBFF" d="M73,52h28v24H73V52z" />
    <path
      fill="#59C1A7"
      d="M78.9,70l4.1-5c0.6-0.8,1.7-0.9,2.5-0.3c0.1,0,0.1,0.1,0.2,0.1l1.2,1.1l3.9-4.8c0.6-0.8,1.7-0.9,2.5-0.3
      c0.1,0.1,0.2,0.2,0.4,0.3L100,69"
    />
    <rect x="73" y="69" fill="#34C3F2" width="28" height="7" />
    <path
      fill="#F2CA1B"
      d="M76,57.5c0,1.3,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S79.8,55,78.5,55S76,56.1,76,57.5z"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="68.8"
      y1="41.2"
      x2="88.2"
      y2="41.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="68.8"
      y1="36.2"
      x2="99.2"
      y2="36.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="68.8"
      y1="31.2"
      x2="94.2"
      y2="31.2"
    />
    <line
      fill="none"
      stroke="#CCC8CA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="68.8"
      y1="26.2"
      x2="104.2"
      y2="26.2"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="52"
      y1="7"
      x2="57"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="38"
      y1="7"
      x2="43"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="24"
      y1="7"
      x2="29"
      y2="7"
    />
    <line
      fill="none"
      stroke="#B8B1B4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="10"
      y1="7"
      x2="15"
      y2="7"
    />
  </SvgIcon>
);
